import React from 'react';

const PLACEMENT_LABELS = {
  'home': 'Home',
  'home_with_services': 'Home + Services',
  'snf': 'SNF',
  'rehab': 'Rehab (IRF)',
  'ltac': 'LTAC',
  'not_ready': 'Not Ready',
};

function WardOverview({ wardResults, wardSummary, onSelectPatient }) {
  if (!wardResults || wardResults.length === 0) return null;

  return (
    <div className="ward-overview">
      {/* Summary Bar */}
      <div className="ward-summary-bar">
        <div className="ward-summary-stat total">
          <span className="ward-stat-number">{wardSummary.total}</span>
          <span className="ward-stat-label">Total Patients</span>
        </div>
        <div className="ward-summary-stat ready">
          <span className="ward-stat-number">{wardSummary.ready}</span>
          <span className="ward-stat-label">Ready</span>
        </div>
        <div className="ward-summary-stat conditional">
          <span className="ward-stat-number">{wardSummary.conditional}</span>
          <span className="ward-stat-label">Conditional</span>
        </div>
        <div className="ward-summary-stat not-ready">
          <span className="ward-stat-number">{wardSummary.not_ready}</span>
          <span className="ward-stat-label">Not Ready</span>
        </div>
        <div className="ward-summary-stat time">
          <span className="ward-stat-number">{wardSummary.processing_time_ms}ms</span>
          <span className="ward-stat-label">Processing</span>
        </div>
      </div>

      {/* Bottlenecks */}
      {wardSummary.bottlenecks && wardSummary.bottlenecks.length > 0 && (
        <div className="ward-bottlenecks">
          <div className="ward-bottleneck-title">Ward Bottlenecks</div>
          <div className="ward-bottleneck-list">
            {wardSummary.bottlenecks.map((b, i) => (
              <div key={i} className="ward-bottleneck-item">
                <span className="ward-bottleneck-type">{b.type}</span>
                <span className="ward-bottleneck-count">{b.count} patients</span>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Patient Priority List */}
      <div className="ward-patient-list">
        <div className="ward-list-header">
          <span className="ward-col-rank">#</span>
          <span className="ward-col-name">Patient</span>
          <span className="ward-col-diagnosis">Diagnosis</span>
          <span className="ward-col-unit">Unit</span>
          <span className="ward-col-placement">Placement</span>
          <span className="ward-col-readiness">Readiness</span>
          <span className="ward-col-barriers">Barriers</span>
          <span className="ward-col-action"></span>
        </div>
        {wardResults.map((r) => (
          <div
            key={r.patientId}
            className={`ward-patient-row readiness-${r.readiness}`}
            onClick={() => onSelectPatient(r.patientId)}
          >
            <span className="ward-col-rank">{r.priority}</span>
            <span className="ward-col-name">
              <div className="ward-patient-name">{r.patientName}</div>
              <div className="ward-patient-sub">Age {r.age} | {r.insurance} | Day {r.daysAdmitted}</div>
            </span>
            <span className="ward-col-diagnosis">
              <span className="ward-diagnosis-badge">{r.diagnosis.code?.slice(0,3)}</span>
              <span className="ward-diagnosis-label">{r.diagnosis.label}</span>
            </span>
            <span className="ward-col-unit">{r.unit}</span>
            <span className="ward-col-placement">
              <span className={`ward-placement-badge ${r.placement === 'not_ready' ? 'not-ready' : r.placement === 'home' ? 'home' : ''}`}>
                {PLACEMENT_LABELS[r.placement] || r.placement}
              </span>
            </span>
            <span className="ward-col-readiness">
              <span className={`ward-readiness-dot ${r.readiness}`} />
              <span className="ward-readiness-text">{r.readiness.replace('_', ' ')}</span>
            </span>
            <span className="ward-col-barriers">
              {r.barriers.length > 0
                ? r.barriers.map(b => (
                    <span key={b} className="ward-barrier-tag">{b.replace(/_/g, ' ')}</span>
                  ))
                : <span className="ward-no-barriers">None</span>
              }
            </span>
            <span className="ward-col-action">
              <button className="ward-detail-btn" onClick={(e) => { e.stopPropagation(); onSelectPatient(r.patientId); }}>
                View
              </button>
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default WardOverview;
